var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"is-vertical"},[_c('layout-header'),_c('layout-main')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }